<template>
    <div class="c__error">
        <app-header></app-header>
        <div class="c__error--layout">
            <div class="c__error--content">
                <h2>Oops, It seems we can’t find what you’re looking for.</h2>
                <a href="/">Go back</a>
            </div>
        </div>
    </div>
</template>

<script>
    import appHeader from '../Header/navigation-bar';
    export default {
        components: {
            appHeader
        },
        computed: {
            getError () {
                if (this.$route.params && this.$route.params.error) {
                    return this.$route.params.error
                }
                return this.error;
            },
            getMessage () {
                if (this.$route.params && this.$route.params.message) {
                    return this.$route.params.message
                }
                return this.error;
            }
        },
        props: {
            error: {
                default: 404,
                type: Number
            },
            message: {
                default: 'File Not Found',
                type: String
            }
        },
        mounted () {

        }
    }
</script>
